import api from './api';

export type BackupSettings = {
  enabled: boolean;
  cron: string;
  localPath: string;
  remotePath?: string;
  retentionDays: number;
  encrypt: boolean;
  encryptionPassphrase?: string;
  allowRestore?: boolean;
};

export type BackupEntry = {
  id: string;
  createdAt: string;
  filePath: string;
  sizeBytes: number;
  encrypted: boolean;
  remotePath?: string | null;
  initiatedBy?: string | null;
  reason?: string | null;
};

export const backupApi = {
  getSettings: async (): Promise<BackupSettings> => {
    const res = await api.get('/admin/backup/settings');
    return res.data?.data;
  },
  updateSettings: async (settings: BackupSettings): Promise<BackupSettings> => {
    const res = await api.put('/admin/backup/settings', { settings });
    return res.data?.data;
  },
  runBackup: async (reason?: string): Promise<BackupEntry> => {
    const res = await api.post('/admin/backup/run', { reason });
    return res.data?.data;
  },
  listHistory: async (): Promise<BackupEntry[]> => {
    const res = await api.get('/admin/backup/history');
    return res.data?.data || [];
  },
  testRemote: async (remotePath?: string): Promise<{ ok: boolean; message: string }> => {
    const res = await api.post('/admin/backup/remote/test', { remotePath });
    return res.data?.data;
  },
  downloadBackup: async (id: string): Promise<Blob> => {
    const res = await api.get(`/admin/backup/download/${id}`, { responseType: 'blob' });
    return res.data as Blob;
  },
  deleteBackup: async (id: string): Promise<{ success: boolean }> => {
    const res = await api.delete(`/admin/backup/${id}`);
    return res.data;
  },
  restoreBackup: async (id: string, confirm: string): Promise<{ success: boolean }> => {
    const res = await api.post('/admin/backup/restore', { id, confirm });
    return res.data;
  },
};
